import React from "react";
import styles from "./WelcomeJourney.module.scss";
import { useSelector } from "react-redux";

const WelcomeJourneyFooter = ({
  btn1ClickHandler,
  btn2ClickHandler,
  heading,
  description,
  ga4tag1,
  ga4tag2,
  btn1_text,
  btn2_text,
}) => {
  const welcomeJourneyStates = useSelector((state) => state.pwa.welcome_journey);
  return (
    <div className={`wc_sticky_btm ${styles.fixed_bottom} ${(welcomeJourneyStates.currentStepNo == 4 || welcomeJourneyStates.currentStepNo == 5) ? styles.opacity_charity_pillar : ""}`}>
      <div className={`${styles.header} large-xs`}>{heading}</div>
      <div className={`x-small-xs ${styles.description}`}>{description}</div>
      <div className={styles.buttonsSection}>
      <button
        className={`btn-primary`}
        onClick={(e) => {
          btn1ClickHandler(e);
        }}
        data-ga4={ga4tag1}
      >
        {btn1_text}
      </button>
      {btn2ClickHandler && (
        <div
          className="x-small-xs underline"
          onClick={(e) => {
            btn2ClickHandler(e);
          }}
          data-ga4={ga4tag2}
        >
          {btn2_text}
        </div>
      )}
      </div>
    </div>
  );
};

export default WelcomeJourneyFooter;
